export class Salutation {
    public static SalutationList: Array<any> = [
        { name: 'Miss', value: 'Miss' },
        { name: 'Mrs.', value: 'Mrs.' },
        { name: 'Mr.', value: 'Mr.' },
        { name: 'Atty.', value: 'Atty.' },
        { name: 'Dr.', value: 'Dr.' },
        { name: 'Eng`r', value: 'Eng`r' },
    ];
}
